<template>
  <section class="tab-nav-wrap" :class="{'cashout-nav-wrap': cashout}">
    <section class="tab-nav-com">
      <div class="list">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane v-for="(list,index) in tabnav" :key="index" :label="list" :name="list"></el-tab-pane>
        </el-tabs>
      </div>
    </section>
    <!-- <keep-alive> -->
      <!-- <router-view :key="activeName"/> -->
    <!-- </keep-alive> -->
  </section>
</template>
<script>
export default {
  data () {
    return {
      activeName: 'Matches',
    }
  },
  props: {
    cashout: {
      default () {
        return false
      }
    },
    parentRouter: {
      type: String
    },
    // tabnav: {
    //   type: Array,
    //   default () {
    //     // return ['Matches', 'Outrights', 'Esport']
    //     return ['Matches', 'Esport']
    //   }
    // }
  },
  watch: {
    '$route.path': {
      handler (val) {
        this.getMatchType()
      }
    },
    tabnav: {
      immediate: true,
      handler (val) {
        const name = (/\/(\w+(-\w+){0,100})\/(\w+(-\w+){0,100})/.exec(this.$route.path) || [])[3] || ''
        if (val.length === 0) {
          this.activeName = name
          this.tabnav.push(this.activeName)
        } else if (!val.includes(this.activeName)) {
          this.activeName = val[0]
          this.handleClick()
        }
      }
    }
  },
  computed: {
    permissionList () {
      const pageName = (/\/(\w+(-\w+){0,100})/.exec(this.$route.path) || [])[1]
      return this.$store.getters.pagePermission[pageName] || {}
    },
    tabnav () {
      const data = []
      if (this.permissionList.matches) {
        data.push('Matches')
      }
      if (this.permissionList.esports) {
        data.push('Esport')
      }
      return data
    }
  },
  created () {
    this.getMatchType()
  },
  methods: {
    getMatchType () {
      if (this.$route.query.matchType) {
        this.activeName = +this.$route.query.matchType === 3 ? 'Esport' : 'Matches'
      } else {
        this.activeName = 'Matches'
      }
    },
    handleClick () {
      // const params = Object.keys(this.$route.params)
      // let path = `/${this.parentRouter}/${this.activeName.replace(/\s/g, '')}`
      // if (params.length > 0) {
      //   path = path + `/${this.$route.params[params[0]]}`
      // }
      // this.$router.push({
      //   path: path,
      //   query: this.$route.query
      // })
      this.$router.replace({
        path: this.$route.path,
        query: { ...this.$route.query, matchType: this.activeName === 'Matches' ? 2 : 3}
      })
    }
  }
}
</script>
<style lang="less" scoped>

.cashout-nav-wrap .tab-nav-com{
    background: linear-gradient(90deg, #193E74 0%, #86365B 118.52%);
}
.xin-app .tab-nav-com {
  background: linear-gradient(90deg, #421B75 -10.34%, #123689 53.47%, #09214D 100.03%);
}
.xin-app.night-mode .tab-nav-com {
  // background:  linear-gradient(90deg, #a3a79d -10.34%, #948989 53.47%, #94908e 100.03%);
}

.tab-nav-com{
  margin-bottom: -6px;
  margin-left: 10px;
 /deep/ .el-tabs__header{
    margin-bottom: 0px;
  }
  // background-image: linear-gradient(to right, #1f4064 0%, #00bfa8 181%, #00bfa8 181%);
  // height: 47px;
  // line-height: 47px;
  // clear: both;
  // overflow: hidden;
  // position: relative;
  /deep/.el-tabs--card>.el-tabs__header .el-tabs__item.is-active{
    background: #f0f0f0;
    // background: var(--bg-primary-light);
    // color:  var(--title-light);
    // border-top: 2px solid #00A791;
  }
  /deep/.el-tabs--card>.el-tabs__header .el-tabs__nav{
    border: none;
    bottom: -1px;
  }
  // /deep/.el-tabs--card>.el-tabs__header .el-tabs__item{
  //   border: none;
  //   color: white;
  // }
  // /deep/ .el-tabs__item{
  //   top: 1px;
  // }
  .list{
    // margin: 5px 0 0 10px;
    // margin-top: 4px;
    // margin-left: 10px;
  }
}
</style>
